// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"GenericPage-Wrapper-1E3obW","Content":"GenericPage-Content-2kjXyE"};